<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [required]="required">{{ label }}</ic-label>
	}
	<div class="picker-content">
		<div class="colorpicker" [style.background]="value">
			<input type="color" [value]="value" (input)="onChange($any($event).target.value)" />
		</div>
		<div class="colors">
			@for (color of colors; track color) {
				<ic-color-option
					data-test="selectColor"
					[class.selected]="color === value"
					[color]="color"
					(click)="onChange(color)"
				/>
			}
		</div>
	</div>
	<ng-content select=".errors" />
</div>
